import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api';

function OrphanedUsersDashboard() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrphanedUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await callApi('listOrphanedUsersV2');
      setUsers(result.users);
    } catch (err) {
      setError('Kunne ikke hente inaktive brukere: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrphanedUsers();
  }, [fetchOrphanedUsers]);

  const handleDeleteUser = async (uid, displayName) => {
    if (window.confirm(`Er du sikker på at du vil slette brukeren "${displayName || uid}"?`)) {
      try {
        await callApi('deleteUserV2', { uid });
        fetchOrphanedUsers(); // Refresh the list
      } catch (err) {
        setError('Kunne ikke slette bruker: ' + err.message);
      }
    }
  };

  if (loading) return <p>Laster inaktive brukere...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <h3>Inaktive Brukere</h3>
      <p>Dette er brukere som er registrert i systemet, men som ikke har tilgang til noen porter eller venter på tilgang.</p>
      
      {users.length === 0 ? (
        <p>Ingen inaktive brukere funnet.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Navn / E-post</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>UID</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Registrert</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', width: '1%', whiteSpace: 'nowrap' }}>Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.uid}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.displayName || user.email || user.uid}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.uid}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.createdAt ? new Date(user.createdAt).toLocaleString() : 'Ukjent'}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px', width: '1%', whiteSpace: 'nowrap' }}>
                  <button onClick={() => handleDeleteUser(user.uid, user.displayName || user.email)} style={{ backgroundColor: 'var(--danger-color)' }}>Slett</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default OrphanedUsersDashboard;
